import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import UserForm from '../../components/forms/UserForm'

const CreateUser = () => {
  return (
    <Container maxWidth='md' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Create User</Typography>
      </Box>
      <UserForm />
    </Container>
  )
}

export default CreateUser
